<!-- AdminLayout.vue -->
<template>
    <v-app>
        <v-card v-if="!user || !user.userdata || !user.userdata.ID" class="rounded-lg fill-height" align="center" justify="center" width="100%" color="transparent">
            <v-card-text class="fill-height">
                <v-row class="fill-height" align="center" justify="center">
                    <v-col>
                        <div class="text-h3 font-weight-bold grey--text darken-4 text-center text-uppercase mb-4">Log In</div>
                        <div class="text-center">
                            <p style="max-width: 500px;margin:auto;">You can log into your account or register a new account.</p>
                            <v-btn color="primary" class="my-8" x-large :href="login_url">Log In</v-btn>
                            <v-btn link text color="primary" x-large :href="registration_url">Register</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-row v-else-if="app.show100ms && !loading && settings == '' && user.isAdmin()">
            <!-- 100 MS -->
            <v-col cols="12" sm="8" offset-sm="2" class="mt-8">
                <one-hundred-ms-settings />
            </v-col>
        </v-row>
        <template v-else>
            <v-navigation-drawer app fixed permanent width="250">
                <!-- Navigation drawer content -->
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 py-2">
                            Account Settings
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list nav>
                    <v-list-item-group :value="active_tab" mandatory>
                        <v-list-item 
                            v-if="user.hasSubscription()"
                            value="rooms" 
                            @click="$router.push({path:`/admin/rooms`})"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-monitor-account</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Rooms</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item 
                            v-for="item in menu_items.filter(item => !item.requires_role || user.hasSubscription())" 
                            :value="item.tab" 
                            @click="$router.push({path:`/admin/${item.tab}`})" :key="item.tab"
                        >
                            <v-list-item-icon>
                                <v-icon>{{item.icon}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{item.title}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item value="settings" @click="$router.push({path:`/admin/settings`})">
                            <v-list-item-icon>
                                <v-icon>mdi-cog</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Settings</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="user.hasRole('administrator')" value="reports" @click="$router.push({path:`/admin/reports`})">
                            <v-list-item-icon>
                                <v-icon>mdi-chart-bar</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Reports</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
                <!-- <v-list nav>
                    <v-list-item @click="$router.push({path:`/admin/100ms`})">
                        <v-list-item-icon>
                            <v-icon>mdi-cog</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>100ms Settings</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list> -->
                <v-list nav>
                    <v-list-item link :href="support_url" target="_blank">
                        <v-list-item-icon>
                            <v-icon>mdi-help-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Support</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                    <v-list nav two-line>
                        <v-list-item link :href="getAccountUrl()">
                            <v-list-item-icon>
                                <v-icon>mdi-account</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Account</v-list-item-title>
                                <v-list-item-subtitle>{{user.userdata.data.user_email}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                
                    <v-list v-if="user.hasRole('administrator')">
                        
                        <v-list-item @click="redirectToExternalUrl('/wp-admin/')">
                            <v-list-item-icon>
                                <v-icon>mdi-cog</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Wordpress Admin</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <template v-slot:append>
                        <v-divider></v-divider>
                        <v-list>
                            <v-list-item link :href="getLogoutUrl()">
                                <v-list-item-icon>
                                    <v-icon>mdi-logout</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Log Out</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </template>
            </v-navigation-drawer>
            <v-main class="custom-main">
                <v-container fluid>
                    <!-- The main content area goes here -->
                    <!-- <router-view></router-view> -->
                    <!-- REPORTS -->
                    <reports v-if="active_tab == 'reports'"></reports>

                    <!-- ROOMS -->
                    <rooms v-else-if="active_tab == 'rooms' && !$route.params.id"></rooms>

                    <!-- 100 MS -->
                    <!-- <one-hundred-ms-settings v-else-if="active_tab == '100ms' && app.show100ms"></one-hundred-ms-settings> -->
                    <settings v-else-if="active_tab == 'settings'"></settings>

                    <!-- ROOM -->
                    <room v-else-if="active_tab == 'rooms' && $route.params.id"></room>

                    <!-- BRANDING -->
                    <branding v-else-if="active_tab == 'branding'"></branding>

                    <!-- RECORDINGS -->
                    <recordings v-else-if="active_tab == 'recordings'"></recordings>

                    <!-- ROLES -->
                    <roles v-else-if="active_tab == 'roles'"></roles>

                    <!-- ACCOUNT -->
                    <account v-else-if="active_tab == 'account'"></account>

                    <!-- REPORTS -->
                    <!-- <reports v-else-if="active_tab == 'reports'"></reports> -->

                    <!-- SITE ADMIN -->
                    <!-- <site v-else-if="active_tab == 'site'"></site> -->
                    

                </v-container>


                
            </v-main>
        </template>
    </v-app>
  </template>
  
  
<script>
import Settings from '../components/admin/Settings.vue'
import Room from '../components/admin/Room.vue'
import Rooms from '../components/admin/Rooms.vue'
import Roles from '../components/admin/Roles.vue'
import Branding from '../components/admin/Branding.vue'
import Recordings from '../components/admin/Recordings.vue'
import Account from '../components/admin/Account.vue'
import Reports from '../components/admin/Reports.vue'
import { useUserStore } from '../stores/user'
import { useAppStore } from '../stores/app'

export default {
    name: 'Admin',
    components: { Settings, Room, Rooms, Branding, Recordings, Roles, Account, Reports },
    created: function() {
        this.user = useUserStore()
        this.app = useAppStore()
    },
    mounted: function() {
        console.log("mounted", !user.userdata || !user.userdata.ID, user.userdata)

        let local_storage_tab = localStorage.getItem('admin_tab') 
        let local_storage_sub_tab = localStorage.getItem('admin_sub_tab') 

        // console.log("local_storage_tab", local_storage_tab)
        // if(local_storage_tab && this.$route.params.tab != local_storage_tab) {
        if(local_storage_tab && !this.$route.params.tab) {
            if(local_storage_tab == "settings" && local_storage_sub_tab)
                this.$router.push({path:`/admin/${local_storage_tab}/${local_storage_sub_tab}`})
            else if(local_storage_tab != 'undefined')
                this.$router.push({path:`/admin/${local_storage_tab}`})
            
        }

        let g = this    
        if(this.app.show100ms) {
            // make sure we have 100ms settings, if not force them to go to the 100ms tab and save
            this.loading = true
            this.user.app.get('meeting/100ms').then(response => {
                g.settings = response.data['100ms']
                g.loading = false
                if(g.user.hasSubscription() && response.data['100ms'] == '') {
                    console.log("push to 100ms")
                    g.$router.push({path:`/admin/100ms`})
                }
            }).catch(error => {
                g.loading = false
            })
        } else {
            this.loading = false
        }
        
    },
    data: function() {
        return {
            loading: true,
            settings: null,
            // tab: this.$route.params.tab ?? localStorage.getItem('admin_tab') ?? 'rooms',
            tab: this.$route.params.tab ?? 'rooms',
            // active_tab: 'rooms',
            menu_items: [
                // { icon:'mdi-monitor-account', tab:'rooms', title:'Rooms', requires_role: true },
                // { icon:'mdi-invert-colors', tab:'branding', title:'Branding' },
                { icon:'mdi-record-circle-outline', tab:'recordings', title:'Recordings', requires_role: true },
                { icon:'mdi-account-supervisor', tab:'roles', title:'Coaching' },
                // { icon:'mdi-cog', tab:'100ms', title:'100ms Settings', requires_role: true },
                // { icon:'mdi-account', tab:'account', title:'Account' },
                // { icon:'mdi-web', tab:'site', title:'Site Admin', requires_role: true },
            ],
            user: null,
            app: null,
        }
    },
    computed: {
        active_tab() {
            return this.$route.params.tab ?? 'rooms'
        },
        login_url() {
            return this.app?.site?.domain_settings?.settings?.domain?.meta?.login_url[0] ?? ''
        },
        registration_url: function() {
            // if(this.app?.site?.domain_settings?.settings?.domain?.meta?.hide_registration_url[0] == '1')
            //     return ''

            let url = this.app?.site?.domain_settings?.settings?.domain?.meta?.registration_url[0] ?? ''
            return url
        },
        support_url: function() {
            return this.app?.site?.domain_settings?.settings?.domain?.meta?.support_url[0] ?? ''
        }
    },
    methods: {
        redirectToExternalUrl(url) {
           window.location.href = url;
        },
        getAccountUrl() {
            return this.app?.site?.domain_settings?.settings?.domain.meta?.profile_url[0]
        },
        getLogoutUrl() {
            let logout_url = this.app?.site?.domain_settings?.settings?.domain?.meta?.logout_url[0] ?? '/wp-logout.php'
            if(logout_url == '/#o-logout-link')
                logout_url = window.location.origin + '/account/#o-logout-link'
            return logout_url
        }

    },
    watch: {
        '$route.params.tab': function(newV, oldV) {
            console.log("watch route tab:", newV, oldV, this.tab)
            localStorage.setItem('admin_tab', newV)
            this.tab = newV
        },
        // 'tab': function(newV, oldV) {
        //     console.log("watch tab", newV, oldV, this.tab)
        // }
    }

}
</script>

<style scoped>
.custom-main {
  padding: 24px !important;
}
</style>